import { render, staticRenderFns } from "./fontLeft.vue?vue&type=template&id=05297d3e&scoped=true"
import script from "./fontLeft.vue?vue&type=script&lang=js"
export * from "./fontLeft.vue?vue&type=script&lang=js"
import style0 from "./fontLeft.vue?vue&type=style&index=0&id=05297d3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05297d3e",
  null
  
)

export default component.exports